import React from 'react';
export function SiteHeader() {
  return <header className="sticky top-0 z-30 w-full border-b border-white/10 bg-navy-900/95 backdrop-blur" data-id="element-185" data-mp="3fmjtjopipf1r">
      <div className="mx-auto flex h-11 w-full max-w-6xl items-center justify-between px-4 sm:px-6" data-id="element-186" data-mp="19v9jlxh7s0bs">
        <span className="font-pixel text-[10px] uppercase tracking-[0.18em] text-white sm:text-xs" data-id="element-187" data-mp="1np0r70bdxa4v">
          Math Made Ready
        </span>
        <span className="font-pixel text-[10px] uppercase tracking-[0.18em] text-brand-gold sm:text-xs" data-id="element-188" data-mp="uxpi50jj0nad">
          2026 Complete Edition
        </span>
      </div>
      <div className="rule-ticks h-[3px] w-full opacity-60" aria-hidden="true" data-id="element-189" data-mp="qyqc1cm26khc" />
    </header>;
}